import React from 'react';
import { connect } from 'react-redux';
import KuposHelmet from '../../../common/KuposHelmet';
import getSlides from '../../functions/getSlides/getSlides';
import ThemeSevenSlider from '../common/ThemeSevenSlider';

const ThemeSevenGalleryScreen = props => {
  return (
    <div className="themes-theme-seven-gallery-screen">
      <KuposHelmet />

      <div id="gallery">
        <div class="new-container">
          <div class="heading">
            <h1>Nuestras fotos</h1>
          </div>
        </div>
      </div>

      <div className="gallery">
        <h3>
          <span>Galería</span>
        </h3>
      </div>
      <ThemeSevenSlider showDots slides={getSlides('Gallery', props.home.operator)} />
    </div>
  );
};

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

export default connect(mapStateToProps, {})(ThemeSevenGalleryScreen);



// WEBPACK FOOTER //
// ./src/features/themes/ThemeSeven/ThemeSevenPages/ThemeSevenGalleryScreen.js